import $ from "jquery";
import Cookies from "js-cookie";

import quilterFunctions from "../helpers/quilter-functions";
import utils from "../helpers/utils";

let occDisabled;

function init(): void {
  const $loginCardButton = $(".js-login-button");
  const $loginHatButton = $(".js-login-hat-button");
  const $modalCloseButton = $(".js-modal-close");
  const $secondaryCta = $(".dialog__footer-body .button--secondary");
  const $loginHatCta = $(".faux-dropdown__cta");
  const currentRole = Cookies.get("Role");

  if ($loginHatButton.length) {
    $loginHatButton.off();

    // The cookies are set in SetLoginCookies() in LoginHelper.cs & this is setting them here to the new values, when the user clicks on the one of the login links.
    $loginHatButton.click(function (e) {
      const $this = $(this);
      const { occLoginLink, occTarget, occModalId, occEnabled, occTimeout } = $this.data();
      occDisabled = isOccDisabled(occEnabled, occLoginLink, currentRole);

      if (currentRole && currentRole.length) {
        if (!occDisabled) {
          e.preventDefault();
          openModal(occModalId);
        }
      }

      initCloseButtons([$modalCloseButton, $secondaryCta], occModalId);
      initSuspendModalCheckboxChange(occTimeout);
    });
  }

  if ($loginCardButton.length) {
    $loginCardButton.off();
    $loginCardButton.click(function (e) {
      e.preventDefault();
      const $this = $(this);
      const { occLoginLink, occLoginText, occTarget, occModalId, occEnabled, occTimeout } = $this.data();

      occDisabled = isOccDisabled(occEnabled, occLoginLink, currentRole);

      if ($modalCloseButton.length) {
        $modalCloseButton.click(function (e) {
          e.preventDefault();
          closeModal(occModalId);
        });
      }

      loginLinkClick(occTarget, occLoginText, occLoginLink, $loginHatCta);
      if (!occDisabled) {
        openModal(occModalId);
      } else {
        if (occLoginLink) {
          window.open(occLoginLink, occTarget);
        }
      }

      initCloseButtons([$modalCloseButton, $secondaryCta], occModalId);
      initSuspendModalCheckboxChange(occTimeout);
    });
  }

  function openModal(id) {
    quilterFunctions.openModal("#" + id);
  }

  function isOccDisabled(occEnabled, occLoginLink, currentRole) {
    return (
      !utils.isStringTrue(occEnabled) ||
      Cookies.get("OCCSuspendModal") !== undefined ||
      Cookies.get("cust-LoginLink") != occLoginLink ||
      currentRole == "adv"
    );
  }
  function loginLinkClick(target, loginText, loginLink, loginButtonTargets): void {
    const $changeLoginLink = $(".js-change-login-link");

    updateRoleCookies(currentRole, loginText, loginLink, target);

    loginButtonTargets.each((i) => {
      if ($(this).length && loginText) {
        $(this).html(loginText).attr("href", loginLink);
      }
    });

    if ($changeLoginLink) {
      $changeLoginLink.removeClass("hidden");
    }
  }

  function updateRoleCookies(role, loginText, loginLink, target) {
    if (role && role.length) {
      Cookies.set(role + "-" + "LoginTitle", loginText, { expires: 365, secure: true });
      Cookies.set(role + "-" + "LoginLink", loginLink, { expires: 365, secure: true });
      Cookies.set(role + "-" + "LoginLinkTarget", target, { expires: 365, secure: true });
    }
  }

  function initSuspendModalCheckboxChange(occTimeout) {
    $(".cbCheckbox").change(function (e) {
      e.preventDefault();
      handlecbFooterChange(e, occTimeout);
    });
  }

  function initCloseButtons(arr: any[], id) {
    arr.forEach((item) => {
      if (item.length) {
        item.click(function (e) {
          closeModal(id);
        });
      }
    });
  }

  function closeModal(id: any) {
    quilterFunctions.closeModal("#" + id);
  }

  function handlecbFooterChange(event, timeout): void {
    if (event.target.checked) {
      return Cookies.set("OCCSuspendModal", "suspended", {
        expires: parseInt(timeout),
        secure: true,
      });
    } else {
      Cookies.remove("OCCSuspendModal");
    }
  }
}

export default { init };
